// Stale data note (TASK-579): shows when a library screen is read-only because the API is
// unreachable. Displays "Showing data from <time>; the API is unreachable" with an aria-live
// region so it announces to screen readers. The note should appear once per screen, with its
// id referenced by aria-describedby on every disabled write control.
import type { ComponentChildren } from "preact";

export interface StaleNoteProps {
  /** Optional id for aria-describedby references from disabled buttons. */
  id?: string;
  /** Optional specific time to show; defaults to now. */
  time?: Date;
}

/**
 * A note showing that data is stale because the API is unreachable.
 * Appears once per read-only screen; its id is referenced by aria-describedby
 * on every disabled write control.
 */
export function StaleNote({ id, time }: StaleNoteProps) {
  const now = time ?? new Date();
  const hours = now.getHours().toString().padStart(2, "0");
  const minutes = now.getMinutes().toString().padStart(2, "0");
  const timeStr = `${hours}:${minutes}`;

  return (
    <div id={id} class="stale-note" aria-live="polite">
      Showing data from {timeStr}; the API is unreachable
    </div>
  );
}
